import withNPS from 'shared/hocs/withNPS'
import NpsModal from '../../shared/components/NpsModal/NpsModal'

const npsModalView = ({ surveyData, isModalOpen, onModalClose, onSubmit, onSkip, showThankYouModal, pending }) =>
    isModalOpen ? (
        <NpsModal
            surveyData={surveyData}
            onSubmit={onSubmit}
            onSkip={onSkip}
            onModalClose={onModalClose}
            showThankYouModal={showThankYouModal}
            pending={pending}
        />
    ) : (
        <></>
    )

export default compose(withNPS)(npsModalView)
